import { render } from "./voiceForm.vue?vue&type=template&id=69f9a142&scoped=true"
import script from "./voiceForm.vue?vue&type=script&lang=js"
export * from "./voiceForm.vue?vue&type=script&lang=js"

import "./voiceForm.vue?vue&type=style&index=0&id=69f9a142&lang=css&scoped=true"

import exportComponent from "D:\\xampp\\htdocs\\jump\\front\\jumpsa\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69f9a142"]])

export default __exports__